<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    :width="width" 
    :height="height" 
    :viewBox="viewBox"
    :aria-labelledby="iconName"
    role="presentation">
    <title :id="iconName" lang="ru">{{iconName}}</title>
    <g :fill="fill">
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    viewBox: {
        type: String,
        default: '0 0 18 18'
    },
    fill: {
        type: String,
        default: 'none'
    }
  }
}
</script>

<style scoped>

</style>